import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
} from 'recharts';
import type { ChartPoint } from '../../hooks/useAnalytics';

interface ProductBarChartProps {
  data: ChartPoint[];
  drillLabel?: string | null;
  onBack?: () => void;
}

export const ProductBarChart = ({ data, drillLabel, onBack }: ProductBarChartProps) => (
  <div className="bg-white rounded-lg border border-slate-200 p-4">
    <div className="flex items-center justify-between mb-4 gap-2">
      <h3 className="text-sm font-semibold text-slate-700">
        {drillLabel ? `Sub-products — ${drillLabel}` : 'Top Products'}
      </h3>
      {drillLabel && (
        <button
          onClick={onBack}
          className="text-xs text-blue-600 hover:text-blue-700 shrink-0"
        >
          ← All products
        </button>
      )}
    </div>
    {data.length === 0 ? (
      <p className="text-xs text-slate-400 py-8 text-center">No data</p>
    ) : (
      <ResponsiveContainer width="100%" height={Math.max(220, data.length * 32)}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 0, right: 24, left: 8, bottom: 0 }}
        >
          <XAxis type="number" tick={{ fontSize: 11 }} allowDecimals={false} />
          <YAxis
            type="category"
            dataKey="name"
            width={120}
            tick={{ fontSize: 11 }}
          />
          <Tooltip
            contentStyle={{ fontSize: 12 }}
            formatter={(v) => [v, 'Conversations']}
          />
          <Bar dataKey="count" fill="#f29003" radius={[0, 3, 3, 0]} />
        </BarChart>
      </ResponsiveContainer>
    )}
  </div>
);
